import http from "@/utils/http";
import { getAccessToken } from "@components/Utils/Utils";
import axios, { CancelToken } from "axios";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const createAccountForPatient = async (accountPatientId) => {
  const token = getAccessToken();
  const url = `/de/react/${token}/patient/create_account_for_patient`;
  return http.post(url, { account_patient_id: accountPatientId });
};

export const verifyPatient = async (email) => {
  const token = getAccessToken();
  const url = `/de/react/${token}/patient/verify_patient`;
  return http.post(url, { email });
};

export const uploadAccountPatientImage = async (accountPatientId, blob) => {
  const token = getAccessToken();
  const url = `/de/react/${token}/upload/upload_account_patient_image`;
  const formData = new FormData();
  formData.append("profileImage", blob);
  formData.append("account_patient_id", accountPatientId);
  return http.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getPatients = async (params, cancelToken) => {
  const token = getAccessToken();
  const { query = "", offset = 0, limit = 50, letters = [], status = [] } = params;
  
  const lettersParam = letters.length
    ? `&letters=${encodeURIComponent(JSON.stringify(letters))}`
    : "";
  
  const statusParam = status.length
    ? `&status=${encodeURIComponent(JSON.stringify(status))}`
    : "";
  
  const filterParams = lettersParam + statusParam;
  
  const url = `${process.env.REACT_APP_SOPHYAPP_API_URL}/de/react/${token}/patient/index/${query}?offset=${offset}&limit=${limit}${filterParams}`;
  
  return axios.get(url, {
    headers: headers,
    cancelToken: cancelToken,
  });
};

/**
 * One patient by id.
 *
 * The endpoint is the patient *index* filtered down to a single id, so it
 * answers with a list — every caller wants the patient. Unwrapping it here
 * rather than in each call site: handing the raw array on produced a "patient"
 * whose `.id` was undefined, which silently turned a patient's program into a
 * template. Resolves with `data: null` when there is no such patient.
 */
export const getPatientById = async (patientId) => {
  const token = getAccessToken();
  const url = `${process.env.REACT_APP_SOPHYAPP_API_URL}/de/react/${token}/patient/index?id=${patientId}`;
  const response = await axios.get(url, { headers });
  return {
    ...response,
    data: Array.isArray(response.data)
      ? response.data[0] ?? null
      : response.data ?? null,
  };
};

export const getLocations = async () => {
  const token = getAccessToken();
  const url = `${process.env.REACT_APP_SOPHYAPP_API_URL}/de/react/${token}/settings/get_locations`;
  return axios.get(url, { headers });
};


